import React from 'react';
import styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';

function GroupNotesCansold() {
    const { t } = useTranslation();

    return (
        <div className={styles.container}>
            「可賣」或「{t('seats')}
            」均非最終{t('IsEnsureGroup')}
            人數，僅為本公司機位或庫存量，「可賣」或「
            {t('seats')}
            」數量將會因供需或旅客取消與否而有增減。
            <span className={styles.important}>
                {t('IsEnsureGroup')}人數仍應以實際銷售結果為準。
            </span>
        </div>
    );
}

export default GroupNotesCansold;
